/**
 * Used in HTTP headers to identify our app.
 */
export const CB_CLIENT = 'com.coinbase.pay';
